import React from 'react';
import PropTypes from 'prop-types';

const EmptyState = ({ colSpan, message = "No Data Available", subMessage = "We couldn't find any records matching your criteria." }) => {
  return (
    <tr className="text-center">
      <td colSpan={colSpan} style={{ padding: '40px 20px' }}>
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div className="mb-0" style={{ 
            opacity: 0.15, 
            background: '#f8f9fa', 
            width: '100px', 
            height: '100px', 
            borderRadius: '50%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center' 
          }}>
            <i className="fas fa-folder-open fa-3x text-muted"></i>
          </div>
          <h5 className="font-weight-bold mb-2" style={{ color: '#4a5568', marginTop: '5px' }}>{message}</h5>
          <p className="text-muted mb-0" style={{ maxWidth: '300px', fontSize: '0.95rem' }}>{subMessage}</p>
        </div>
      </td>
    </tr>
  );
};

EmptyState.propTypes = {
  colSpan: PropTypes.number.isRequired,
  message: PropTypes.string,
  subMessage: PropTypes.string
};

export default EmptyState;
